module.exports = __webpack_public_path__ + "static/media/report1.4a58337c.png";